<template>
  <div>
    <div class="d-flex align-center">
      <h3>Produtos mais vendidos</h3>
      <v-spacer></v-spacer>
    </div>

    <v-divider class="ma-2"></v-divider>
    <v-data-table
      :items="productSales"
      :loading="prdloading"
      :headers="prdHeaders"
      class="content-table"
      hide-default-footer
      loading-text="Buscando..."
      no-data-text="Sem registros"
    >
      <template v-slot:[`item.salesValue`]="{ item }">
        {{
          item.salesValue.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          })
        }}
      </template>

      <template v-slot:footer class="ma-0 pa-0">
        <section class="ma-0 pa-0">
          <Pagination
              v-if="totalItems > pageSize"
              :currentPage="currentPage"
              :totalItems="totalItems"
              :page="page"
              :pageSize="pageSize"
              :totalPages="totalPages"
              @back-page="backPage"
              @next-page="nextPage"
          >
          </Pagination>
        </section>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "ProductDashResale",
  components: {Pagination},

  props: {
    filter: {
      resaleId: "",
      startDate: "",
      endDate: "",
    },
  },

  data() {
    return {
      productSales: [],
      page: 1,
      pageSize: 10,
      currentPage: 1,
      totalItems: 1,
      totalPages: 1,
      prdHeaders: [
        {
          text: "Produto",
          align: "center",
          value: "product",
        },
        {
          text: "Quantidade",
          align: "center",
          value: "salesQuantity",
          sortable: false,
        },
        {
          text: "Valor",
          align: "center",
          value: "salesValue",
        },
      ],
      headerProps: {
        sortByText: "Ordenar por",
      },

      prdloading: false,
      apiService: new ApiService(),
    };
  },

  created() {
    this.getProductSales();
  },

  methods: {
    getProductSales() {
      this.prdloading = true;
      this.apiService
        .post("dashresale/products", { ...this.filter, page: this.page })
        .then((response) => {
          this.productSales = response.content.data;
          this.totalPages = response.content.pager.totalPages;
          this.currentPage = response.content.pager.currentPage;
          this.totalItems = response.content.pager.totalItems;
          this.prdloading = false;
        })
        .catch(() => {
          this.prdloading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      await this.getProductSales();
    },

    async nextPage() {
      this.page += 1;
      await this.getProductSales();
    },
  },



  watch: { },
};
</script>

<style></style>
